import React, { useState, useEffect } from 'react';
import { clienteService } from '../services/api';
import '../styles/Clientes.css';

const Clientes = () => {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [filtroSegmento, setFiltroSegmento] = useState('');
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    direccion: '',
    segmento: 'potencial',
    notas: ''
  });

  useEffect(() => {
    cargarClientes();
  }, [filtroSegmento]);

  const cargarClientes = async () => {
    try {
      const params = filtroSegmento ? { segmento: filtroSegmento } : {};
      const response = await clienteService.getAll(params);
      setClientes(response.data);
    } catch (error) {
      console.error('Error al cargar clientes:', error);
    } finally {
      setLoading(false);
    }
  };

  const abrirModal = (cliente = null) => {
    if (cliente) {
      setClienteSeleccionado(cliente);
      setFormData({
        nombre: cliente.nombre,
        email: cliente.email || '',
        telefono: cliente.telefono || '',
        direccion: cliente.direccion || '',
        segmento: cliente.segmento,
        notas: cliente.notas || ''
      });
    } else {
      setClienteSeleccionado(null);
      setFormData({
        nombre: '',
        email: '',
        telefono: '',
        direccion: '',
        segmento: 'potencial',
        notas: ''
      });
    }
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setClienteSeleccionado(null);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (clienteSeleccionado) {
        await clienteService.update(clienteSeleccionado.id, formData);
      } else {
        await clienteService.create(formData);
      }
      cargarClientes();
      cerrarModal();
    } catch (error) {
      console.error('Error al guardar cliente:', error);
      alert(error.response?.data?.error || 'Error al guardar cliente');
    }
  };

  const handleEliminar = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar este cliente?')) return;

    try {
      await clienteService.delete(id);
      cargarClientes();
    } catch (error) {
      console.error('Error al eliminar cliente:', error);
      alert(error.response?.data?.error || 'Error al eliminar cliente');
    }
  };

  if (loading) {
    return <div className="loading">Cargando clientes...</div>;
  }

  return (
    <div className="clientes-container">
      <div className="page-header">
        <h1>Clientes</h1>
        <button className="btn btn-primary" onClick={() => abrirModal()}>
          + Nuevo Cliente
        </button>
      </div>

      <div className="filtros">
        <select
          value={filtroSegmento}
          onChange={(e) => setFiltroSegmento(e.target.value)}
          className="filtro-segmento"
        >
          <option value="">Todos los segmentos</option>
          <option value="potencial">Potencial</option>
          <option value="activo">Activo</option>
          <option value="inactivo">Inactivo</option>
        </select>
      </div>

      {clientes.length === 0 ? (
        <div className="empty-state">
          <p>No hay clientes registrados</p>
          <button className="btn btn-primary" onClick={() => abrirModal()}>
            Crear primer cliente
          </button>
        </div>
      ) : (
        <div className="clientes-grid">
          {clientes.map(cliente => (
            <div key={cliente.id} className="cliente-card">
              <div className="cliente-header">
                <h3>{cliente.nombre}</h3>
                <span className={`segmento-badge ${cliente.segmento}`}>
                  {cliente.segmento}
                </span>
              </div>

              <div className="cliente-info">
                {cliente.email && (
                  <p><strong>Email:</strong> {cliente.email}</p>
                )}
                {cliente.telefono && (
                  <p><strong>Teléfono:</strong> {cliente.telefono}</p>
                )}
                {cliente.direccion && (
                  <p><strong>Dirección:</strong> {cliente.direccion}</p>
                )}
              </div>

              <div className="cliente-stats">
                <div className="stat">
                  <span className="stat-value">{cliente.total_cotizaciones || 0}</span>
                  <span className="stat-label">Cotizaciones</span>
                </div>
                <div className="stat">
                  <span className="stat-value">{cliente.total_proyectos || 0}</span>
                  <span className="stat-label">Proyectos</span>
                </div>
              </div>

              <div className="cliente-actions">
                <button
                  className="btn btn-secondary"
                  onClick={() => abrirModal(cliente)}
                >
                  Editar
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => handleEliminar(cliente.id)}
                >
                  Eliminar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {modalAbierto && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>{clienteSeleccionado ? 'Editar Cliente' : 'Nuevo Cliente'}</h2>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nombre *</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  placeholder="Nombre del cliente"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="email@ejemplo.com"
                  />
                </div>

                <div className="form-group">
                  <label>Teléfono</label>
                  <input
                    type="tel"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    placeholder="+1234567890"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Dirección</label>
                <input
                  type="text"
                  name="direccion"
                  value={formData.direccion}
                  onChange={handleChange}
                  placeholder="Dirección completa"
                />
              </div>

              <div className="form-group">
                <label>Segmento</label>
                <select
                  name="segmento"
                  value={formData.segmento}
                  onChange={handleChange}
                >
                  <option value="potencial">Potencial</option>
                  <option value="activo">Activo</option>
                  <option value="inactivo">Inactivo</option>
                </select>
              </div>

              <div className="form-group">
                <label>Notas</label>
                <textarea
                  name="notas"
                  value={formData.notas}
                  onChange={handleChange}
                  rows="3"
                  placeholder="Notas adicionales sobre el cliente"
                />
              </div>

              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  {clienteSeleccionado ? 'Actualizar' : 'Crear'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Clientes;
